<template>
  <div :class="classes">
    <label
      :class="[prefixCls + '-label']"
      :style="labelStyles"
      v-if="label || $slots.label"
    >
      {{ label }}{{ colon }}
    </label>
    <div :class="[prefixCls + '-content']" :style="contentStyles">
      <slot></slot>
    </div>
  </div>
</template>

<script>
const prefixCls = 'view-item';
export default {
  name: 'ViewItem',
  data () {
    return {
      prefixCls
    };
  },
  computed: {
    classes () {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-required`]: this.required
        }
      ];
    },
    labelStyles () {
      const style = {};
      if (this.labelWidth || this.labelWidth === 0) {
        style.width = `${this.labelWidth}px`;
      }
      return style;
    },
    contentStyles () {
      const style = {};
      if (this.labelWidth || this.labelWidth === 0) {
        style.marginLeft = `${this.labelWidth}px`;
      }
      return style;
    },
    colon () {
      let colon = '';
      if (this.labelColon) {
        colon = typeof this.labelColon === 'boolean' ? ':' : this.labelColon;
      }
      return colon;
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    labelWidth: {
      type: Number
    },
    required: {
      type: Boolean,
      default: false
    },
    labelColon: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped lang="less">
@import url('./view-item.less');
</style>
